module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Landing-page.179e5527.jpg";